<template>
	<section class="promotions main-content align-center">
		<div class="row small-row">
			<div v-parse-links class="columns column12" v-html="header" />
		</div>
		<div class="row promotions-row flex-row slide-row">
			<div v-for="promoblock in items.slice(0, amount)" :key="promoblock.filename" class="block flex-item">
				<nuxt-link :to="localePath(`/${promoblock.link}`)">
					<picture>
						<source v-if="promoblock.imageWebp" :srcset="promoblock.imageWebp" type="image/webp" />
						<source :srcset="promoblock.image" />
						<img loading="lazy" :src="promoblock.image" :alt="promoblock.imageAlt" />
					</picture>
				</nuxt-link>
				<div class="block-content">
					<h3>
						<nuxt-link :to="localePath(`/${promoblock.link}`)">
							{{ promoblock.header }}
						</nuxt-link>
					</h3>
					<div v-parse-links v-html="promoblock.content" />
					<nuxt-link :to="localePath(`/${promoblock.link}`)" class="button button-no-fill">
						{{ promoblock.button }}
					</nuxt-link>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
	header: { type: String, default: '' },
});
</script>
